import useI18n from '@/hooks/useI18n';
import React from 'react';
import CustomCheckbox from '../CustomCheckbox';
import { FormDataForCreateCampaign } from '@/types/interfaces';
import { formatPercent } from '@/utils/numberUtils';
interface ChooseContentComponentProps {
  formData: FormDataForCreateCampaign;
}
const ChooseContentComponent: React.FC<ChooseContentComponentProps> = ({
  formData,
}) => {
  const { t } = useI18n();

  const tabs = [
    ...(Array.isArray(formData.reelCashbackRange) &&
    formData.reelCashbackRange.length === 2 &&
    formData.reelMaxCashback &&
    formData.reelPlatforms?.[0]
      ? [
          {
            name: t('common.reel'),
            subTitle: t('common.reelDesc'),
            icon: '/assets/video.svg',
            cashbackRange: `Upto ${formatPercent(formData.reelCashbackRange[1])}`,
            maxCashback: formData.reelMaxCashback,
            platform: formData.reelPlatforms[0],
            platformIcon:
              (formData.reelPlatforms.includes('instagram') &&
                formData.reelPlatforms.includes('tiktok')) ||
              formData.reelPlatforms.includes('both')
                ? ['/assets/FullInstagram.svg', '/assets/FullTikTok.svg']
                : formData.reelPlatforms[0] === 'instagram'
                  ? ['/assets/FullInstagram.svg']
                  : formData.reelPlatforms[0] === 'tiktok'
                    ? ['/assets/FullTikTok.svg']
                    : [],
          },
        ]
      : []),

    ...(Array.isArray(formData.postCashbackRange) &&
    formData.postCashbackRange.length === 2 &&
    formData?.postMaxCashback &&
    formData?.postPlatforms?.[0]
      ? [
          {
            name: t('common.post'),
            subTitle: t('common.postDesc'),
            icon: '/assets/post.svg',
            cashbackRange: `Upto ${formatPercent(formData.postCashbackRange[1])}`,
            maxCashback: formData.postMaxCashback,
            platform: formData.postPlatforms[0],
            platformIcon:
              (formData.postPlatforms.includes('instagram') &&
                formData.postPlatforms.includes('tiktok')) ||
              formData.postPlatforms.includes('both')
                ? ['/assets/FullInstagram.svg', '/assets/FullTikTok.svg']
                : formData.postPlatforms[0] === 'instagram'
                  ? ['/assets/FullInstagram.svg']
                  : formData.postPlatforms[0] === 'tiktok'
                    ? ['/assets/FullTikTok.svg']
                    : [],
          },
        ]
      : []),

    ...(Array.isArray(formData.storyCashbackRange) &&
    formData.storyCashbackRange.length === 2 &&
    formData.storyMaxCashback &&
    formData.storyPlatforms?.[0]
      ? [
          {
            name: t('common.story'),
            subTitle: t('common.storyDesc'),
            icon: '/assets/tv.svg',
            cashbackRange: `Upto ${formatPercent(formData.storyCashbackRange[1])}`,
            maxCashback: formData.storyMaxCashback,
            platform: formData.storyPlatforms[0],
            platformIcon: ['/assets/FullInstagram.svg'],
          },
        ]
      : []),
  ];

  return (
    <div className="p-4 gap-[20px] flex flex-col">
      <div className="flex gap-4 items-center">
        <div className="w-[32px] h-[32px] bg-[#06B217] text-white rounded-full text-2xl text-center">
          3
        </div>
        <span className="text-[#172B4D] text-base font-semibold">
          {t('common.chooseContentTypeAndCashback')}
        </span>
      </div>
      <div className="flex flex-col gap-4">
        {tabs.map((tab) => (
          <div
            key={tab.name}
            className="flex justify-between p-2 w-full items-end"
          >
            <div>
              <span className="text-[#9B919D] text-sm font-normal max-w-[315px]">
                {t('common.contentFormat')}
              </span>
              <div className="flex items-center gap-3">
                <CustomCheckbox
                  name="contentType"
                  value={tab.name}
                  checked={true}
                  readOnly
                  screen="preview"
                />
                <img
                  className="h-[24px] w-[24px]"
                  src={tab.icon}
                  alt={tab.name}
                />
                <div className="flex flex-col min-w-[250px]">
                  <span className="text-[#020D3A] text-base font-normal">
                    {tab.name}
                  </span>
                  <span className="text-[#020D3A] text-base font-normal">
                    {tab.subTitle}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex flex-col items-start w-[150px]">
              <span className="text-[#9B919D] text-sm font-normal">
                {t('common.cashbackRange')}
              </span>
              <span className="text-[#292828] text-lg font-normal">
                {tab.cashbackRange}
              </span>
            </div>
            <div className="flex flex-col items-start w-[220px]">
              <span className="text-[#9B919D] text-sm font-normal">
                {t('common.maximumCashbackAllowed')}
              </span>
              <span className="text-[#292828] text-lg font-normal">
                {tab.maxCashback}
              </span>
            </div>
            <div className="flex flex-row gap-4 items-center justify-center w-[280px]">
              {tab.platformIcon.map((item) => {
                return (
                  <div
                    key={item}
                    className={`px-4 py-2.5 flex flex-row gap-5 rounded-full bg-white border border-[#020D3A]`}
                  >
                    <img src={item} alt={item} className="w-[82px] h-[24px]" />
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChooseContentComponent;
